import request from './request';

export async function getOwnVdsOfUser(userId) {
  const res = await request.get(`/portal/api/users/${userId}/ownvds`);
  return res.data;
}

export async function getVdsOfUser(userId, approvalId) {
  const res = await request.get(`/portal/api/users/${userId}/vds`, { params: { approvalId } });
  return res.data;
}

export async function getVdGroups() {
  const res = await request.get(`/portal/api/users/vd-groups`);
  return res.data;
}

export async function getUser(user) {
  const res = await request.get(`/portal/api/users`, { params: { user } });
  return res.data;
}

// FIXME
export default getVdsOfUser;
